import { Platform } from "react-native";
import { VIDEO_SERVER_BASE_URL } from "../config/videoServer";

const ACCESS_DECISION_TIMEOUT_MS = 4_500;

export type VisitorAccessDecision = {
  allowed: boolean;
  action?: "allow" | "block";
  message?: string;
  matchedRule?: { id: string; name: string; scope: "site" | "video" } | null;
};

function visitorId() {
  if (Platform.OS !== "web" || typeof window === "undefined") return "native-app";
  return window.localStorage.getItem("neptuneVisitorId") || "anonymous-web";
}

export async function checkVisitorAccess(
  scope: "site" | "video" = "site",
  videoId = "",
  videoTitle = "",
): Promise<VisitorAccessDecision> {
  if (Platform.OS !== "web" || typeof window === "undefined") return { allowed: true };
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), ACCESS_DECISION_TIMEOUT_MS);
  try {
    const response = await fetch(`${VIDEO_SERVER_BASE_URL}/api/access-decision`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal: controller.signal,
      body: JSON.stringify({
        scope,
        videoId,
        videoTitle,
        visitorId: visitorId(),
        path: window.location.href,
        title: document.title,
        referrer: document.referrer,
        language: navigator.language || "",
        languages: Array.isArray(navigator.languages) ? navigator.languages.join(",") : "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        screen: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
      }),
    });
    if (!response.ok) throw new Error(`Access decision failed (${response.status})`);
    return await response.json();
  } catch {
    // Fail open when the policy service is temporarily unreachable, so a local API outage
    // does not permanently lock the operator out of the public site.
    return { allowed: true };
  } finally {
    window.clearTimeout(timeoutId);
  }
}
